<!-- 目前弃用 -->
<template>
    <div class="invoice-recharge flex-column">
        <date-picker @changeDate="getPickDate" :date.sync="query.date" type="year-month" title="选择年月">
            <template #left>
                <div class="invoice-header-batch flex align-center" v-if="!isBatch" @click="isBatch = true">
                    <img src="@/assets/images/invocie/batch.png" alt="" />
                    <span>批量开票</span>
                </div>
                <van-checkbox v-model="checkAll" @click="checkAllChange" v-else>
                    <div class="invoice-header-left flex align-center">
                        <span style="color: #009af3">全选</span>
                        <div class="invoice-header-cancle flex align-center" @click.stop="isBatch = false">
                            <img src="@/assets/images/invocie/cancle.png" alt="" />
                            <span>取消</span>
                        </div>
                    </div>
                </van-checkbox>
            </template>
        </date-picker>

        <div class="invoice-content">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" :finished-text="invoiceList.length == 0 ? '' : '暂无更多了'" @load="onLoad">
                    <template #default>
                        <van-checkbox-group v-model="result" ref="invoiceCheckbox" @change="invoiceitemChange">
                            <div class="invoice-item flex align-center" v-for="(item, index) in invoiceList" :key="index" @click.stop="toCreateInvoice(item)">
                                <van-checkbox :name="item.id" v-if="isBatch"></van-checkbox>
                                <div class="invoice-item-content">
                                    <div class="invoice-item-header flex align-center justify-between">
                                        <p class="invoice-item-header-left">{{ item.name }}</p>
                                        <p class="invoice-item-header-right text-price">{{ item.price }}</p>
                                    </div>
                                    <div class="invoice-item-footer flex align-center justify-between">
                                        <p class="invoice-item-footer-left">{{ item.date }}</p>
                                        <p class="invoice-item-footer-right">
                                            余额&nbsp&nbsp<span class="text-price">{{ item.balance }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </van-checkbox-group>
                    </template>
                </van-list>
            </van-pull-refresh>
        </div>
        <van-empty description="暂无记录" v-if="invoiceList.length == 0" />
        <div class="invoice-confirm" v-if="isBatch">
            <van-button class="comfirm-btn" color="#009AF3 ">开票</van-button>
        </div>
    </div>
</template>

<script>
import DatePicker from "@/components/base/datePicker/date-picker.vue";

export default {
    name: "InvoiceRecharge",
    components: {
        DatePicker,
    },
    data() {
        return {
            checkAll: false,
            query: {
                date: "",
            },
            isBatch: false,
            result: [],
            invoiceList: [
                {
                    name: "充值-微信支付",
                    price: "1288.10",
                    date: "2021-03-01 12:12:12",
                    balance: "131.21",
                    id: 1,
                },
                {
                    name: "停车缴费-余额支付",
                    price: "1288.10",
                    date: "2021-03-01 12:12:12",
                    balance: "131.21",
                    id: 2,
                },
            ],
            loading: false,
            finished: false,
            refreshing: false,
        };
    },
    mounted() {},
    methods: {
        checkAllChange(value) {
            this.$refs.invoiceCheckbox.toggleAll(this.checkAll);
        },
        // 时间选择搜索
        getPickDate(value) {
            this.showDatePick = false;
        },
        // 复选框组修改事件
        invoiceitemChange() {
            if (this.result.length == this.invoiceList.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },
        onLoad() {
            setTimeout(() => {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }

                for (let i = 0; i < 10; i++) {
                    this.invoiceList.push({
                        name: "停车缴费-余额支付",
                        price: "1288.10",
                        date: "2021-03-01 12:12:12",
                        balance: "131.21",
                        id: 2,
                    });
                }
                this.loading = false;

                if (this.invoiceList.length >= 40) {
                    this.finished = true;
                }
            }, 1000);
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.onLoad();
        },
        // 开票
        toCreateInvoice(item) {
            if (this.isBatch) {
            } else {
                this.$router.push("/invoice/invoiceCreate");
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";
.invoice-recharge {
    min-height: 100vh;
    .invoice-header {
        width: 750px;
        height: 90px;
        padding: 30px;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #fff;
        z-index: 99;

        .invoice-date {
            font-size: 28px;
            color: #666666;

            i {
                margin: 0 4px;
            }
        }
        .invoice-header-cancle {
            margin-left: 30px;
            img {
                width: 32px;
                height: 32px;
                margin-right: 15px;
            }
        }
        .invoice-header-batch {
            margin-left: 30px;
            color: @main-color;
            img {
                width: 32px;
                height: 32px;
                margin-right: 15px;
            }
        }
    }
    .invoice-content {
        margin-top: 100px;
        padding-bottom: 140px;
        background-color: #fff;
        .invoice-item {
            padding: 30px;
            border-bottom: 1px solid #dbdada33;
            .invoice-item-content {
                flex: 1;
                margin-left: 16px;
                .invoice-item-header {
                    .invoice-item-header-left {
                        font-size: 30px;
                        color: #333333;
                    }
                    .invoice-item-header-right {
                        font-size: 30px;
                        color: #1fba34;
                    }
                }
                .invoice-item-footer {
                    margin-top: 13px;
                    .invoice-item-footer-left {
                        font-size: 24px;
                        color: #999999;
                    }
                    .invoice-item-footer-right {
                        font-size: 24px;
                        color: #999999;
                    }
                }
            }
        }
    }
    .invoice-confirm {
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        padding: 24px;
        margin-top: auto;
    }
}
</style>
